module.exports = __webpack_public_path__ + "static/img/2_2_4.a5e7f72e.jpg";